import { render } from "./Marketplace.vue?vue&type=template&id=229dd376"
import script from "./Marketplace.vue?vue&type=script&lang=js"
export * from "./Marketplace.vue?vue&type=script&lang=js"

import "./Marketplace.vue?vue&type=style&index=0&id=229dd376&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/ddv-home/Marketplace.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "229dd376"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('229dd376', __exports__)) {
    api.reload('229dd376', __exports__)
  }
  
  module.hot.accept("./Marketplace.vue?vue&type=template&id=229dd376", () => {
    api.rerender('229dd376', render)
  })

}


export default __exports__